import { render, staticRenderFns } from "./PostingProcessingPrototype.vue?vue&type=template&id=2b0ad3e1&scoped=true&"
import script from "./PostingProcessingPrototype.vue?vue&type=script&lang=js&"
export * from "./PostingProcessingPrototype.vue?vue&type=script&lang=js&"
import style0 from "./PostingProcessingPrototype.vue?vue&type=style&index=0&id=2b0ad3e1&prod&lang=css&"
import style1 from "./PostingProcessingPrototype.vue?vue&type=style&index=1&id=2b0ad3e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0ad3e1",
  null
  
)

export default component.exports